import { render, staticRenderFns } from "./orthobuilder.vue?vue&type=template&id=31216da3&scoped=true"
import script from "./orthobuilder.vue?vue&type=script&lang=js"
export * from "./orthobuilder.vue?vue&type=script&lang=js"
import style0 from "./orthobuilder.vue?vue&type=style&index=0&id=31216da3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31216da3",
  null
  
)

export default component.exports